var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/16/refresh-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3890782,5.34427344 C10.3502822,4.38661719 8.96908527,3.85920312 7.5,3.85920312 L6.69364926,3.85920312 L7.98787309,2.66314063 L7.26676666,2 L4.74614837,4.32942969 L7.23386892,6.66117969 L7.96003458,6.00275 L6.67486144,4.79815625 L7.5,4.79815625 C9.97109371,4.79815625 11.9814918,6.6515 11.9814918,8.92960156 C11.9814918,11.2077031 9.97109371,13.0610469 7.5,13.0610469 C5.02890629,13.0610469 3.01850816,11.2076797 3.01850816,8.92950781 L3.01850816,8.46003125 L2,8.460125 L2,8.92960156 C2,10.2839609 2.57210047,11.55725 3.61092185,12.5149063 C4.6497178,13.4725859 6.03091473,14 7.5,14 C8.96908527,14 10.3502822,13.4725859 11.3890782,12.5149063 C12.4278995,11.5572266 13,10.2839375 13,8.92960156 C13,7.57526563 12.4278995,6.30195313 11.3890782,5.34427344 Z",
    id: "Path",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9dcb98b3ff77de801f32a7a6fb979685.svg";
export { ForwardRef as ReactComponent };